<script setup>
  import { useLocalePath } from '#i18n'
  import { computed } from 'vue'

  defineEmits(['focus', 'blur'])

  const { menuMain } = useMainMenu()
  const { dropdown } = defineProps({
    dropdown: {
      type: String,
      default: ''
    }
  })
  const localePath = useLocalePath()
  const menu = computed(() => {
    return menuMain?.value?.[dropdown]
  })
</script>
<template>
  <div class="text-black p-6 bg-white rounded-xl border-4 border-slate-100" :class="menu.menuCss">
    <div>
      <h3 class="text-slate-700 font-semibold text-sm uppercase tracking-wider mb-4">{{ menu.title }}</h3>
      <div class="grid gap-x-8 gap-y-3" :class="menu.gridCss">
        <div v-for="item in menu.items" :key="item.title" class="flex items-center group">
          <div class="p-1 rounded mr-3" :class="item.iconCss">
            <font-awesome class="fa-fw" :icon="['fal', item.icon]" />
          </div>
          <NuxtLink
            :to="localePath({ name: item.path, params: item.params || {} })"
            class="grow text-slate-800 font-medium text-sm transition-colors"
            :class="item.linkCss"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
          >
            {{ item.title }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>
